export default __webpack_public_path__ + "static/media/ManageDevices.d91cbf94.svg";